import classNames from "classnames";
import CloseIcon from "@/sprout/icons/close";
import CheckMarkIcon from "@/sprout/icons/check_mark";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

const Toggle = ({ checked, onChange, disabled = false, ariaLabel }: ToggleProps) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={classNames(
        "relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
        checked ? "bg-green-700!" : "bg-gray-800!",
      )}
    >
      <span className="pointer-events-none absolute inset-y-0 left-1 flex items-center">
        <CheckMarkIcon size="xs" color="white" viewBox="0 0 16 16" ariaHidden />
      </span>
      <span className="pointer-events-none absolute inset-y-0 right-1 flex items-center">
        <CloseIcon size="xs" color="white" ariaHidden />
      </span>
      <span
        className={classNames(
          "pointer-events-none relative inline-flex h-5 w-5 rounded-full bg-white shadow transition-transform",
          checked ? "translate-x-[22px]" : "translate-x-0.5",
        )}
      />
    </button>
  );
};

export default Toggle;
